var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.673,
    height: 33.025,
    viewBox: "0 0 32.673 33.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M0,0A15.836,15.836,0,0,1,15.836,15.836,15.836,15.836,0,0,1,0,31.673",
    transform: "translate(0 33.025) rotate(-90)",
    fill: "none",
    stroke: "#256f92",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    transform: "translate(8.17)",
    fill: "none",
    stroke: "#256f92",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.665,
    cy: 7.665,
    r: 7.665,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.665,
    cy: 7.665,
    r: 7.165,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.e9e488c775e5daad6ba75ad76faa2a8e.svg";
export { ForwardRef as ReactComponent };